import React, { Fragment, useState, useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  tableCellClasses,
  Paper,
  CircularProgress,
  InputAdornment,
  IconButton,
  Dialog,
  // DialogActions,
  DialogContent,
  DialogTitle,
  //   Checkbox,
  //   Button,
} from "@mui/material";
import {
  //  CheckIcon,
  FontFamily,
  // PendingIcon,
  SearchIcon,
} from "assets";
import Colors from "assets/Style/Colors";
import { PrimaryButton } from "components/Buttons";
import SelectField from "components/Select";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import { makeStyles } from "@mui/styles";
import {
  Visibility as VisibilityIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import DropdownMenu from "components/DropDown";
import Pagination from "components/Pagination";
import { ErrorToaster } from "components/Toaster";
import InputField from "components/Input";
import SupplierServices from "services/Supplier";
import { Debounce, CommaSeparator } from "utils";
// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";
import { formatPermissionData } from "utils";
import { addPermission } from "redux/slices/navigationDataSlice";
import { useDispatch } from "react-redux";
// *For Table Style
const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    textAlign: "center",
    whiteSpace: "nowrap",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    textWrap: "nowrap",
    padding: "5px !important",

    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

const useStyles = makeStyles({
  loaderWrap: {
    display: "flex",
    height: 100,
    "& svg": {
      width: "40px !important",
      height: "40px !important",
    },
  },
});
const errorBorderSx = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": { borderColor: "red" },
    "&:hover fieldset": { borderColor: "red" },
    "&.Mui-focused fieldset": { borderColor: "red" },
  },
  "& .MuiInputLabel-root": { color: "red" },
};
function SupplierListing() {

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm();
  const [loader, setLoader] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [supplierData, setSupplierData] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({});
  const [permissions, setPermissions] = useState({});
  const dispatch = useDispatch();

  // Invoice modal states
  const [invoiceSupplier, setInvoiceSupplier] = useState(null);
  const [invoiceBills, setInvoiceBills] = useState([]);
  const [invoiceLoader, setInvoiceLoader] = useState(false);
  const [invoiceTotalCount, setInvoiceTotalCount] = useState(0);
  const [invoiceCurrentPage, setInvoiceCurrentPage] = useState(1);
  const [invoicePageLimit, setInvoicePageLimit] = useState(20);
  const [invoiceSearch, setInvoiceSearch] = useState("");

  const handleMenuToggle = (menuId, isOpen) => {
    setActiveMenu(isOpen ? menuId : null);
  };
  const navigate = useNavigate();

  const tableHead = [
    "Supplier Code",
    "Supplier Name",
    "Credit Limit  (AED)",
    "Balance Due ($)",
    "Overdue",
    "Status",
    "Invoices",
    "Action",
  ];

  const handleOpenPopup = (item) => {
    setInvoiceSupplier(item);
    setInvoiceSearch("");
    setInvoiceCurrentPage(1);
    setOpenPopup(true);
    getSupplierInvoices(item?.id, 1, 20, "");
  };

  const getSupplierInvoices = async (supplierId, page, limit, search) => {
    setInvoiceLoader(true);
    try {
      const params = {
        page: page || 1,
        limit: limit || 10,
        supplier_id: supplierId,
      };
      if (search) params.search = search;
      const data = await SupplierServices.getBill(params);
      setInvoiceBills(data?.data?.bills?.rows ?? []);
      setInvoiceTotalCount(data?.data?.bills?.count ?? 0);
      setInvoiceCurrentPage(page || 1);
      setInvoicePageLimit(limit || 10);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setInvoiceLoader(false);
    }
  };

  const toNumber = (value) => {
    if (value === null || value === undefined || value === "") return 0;
    if (typeof value === "number") return Number.isFinite(value) ? value : 0;

    const normalized = String(value).replace(/,/g, "").trim();
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const getBalanceDue = (supplier) => {
    const bills = Array.isArray(supplier?.supplier_bills)
      ? supplier.supplier_bills
      : [];

    const totalBillAmount = bills.reduce(
      (sum, bill) => {
        const billAccounts = Array.isArray(bill?.bill_accounts)
          ? bill.bill_accounts
          : [];

        const accountTotal = billAccounts.reduce(
          (accountSum, account) => accountSum + toNumber(account?.total_amount),
          0,
        );

        return sum +
          (toNumber(bill?.total_amount) || accountTotal || toNumber(bill?.bill_amount));
      },
      0,
    );
    const totalPaidAmount = bills.reduce(
      (sum, bill) => sum + toNumber(bill?.paid_amount),
      0,
    );

    return totalBillAmount - totalPaidAmount;
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
    setInvoiceSupplier(null);
    setInvoiceBills([]);
    setInvoiceSearch("");
  };

  const sanitizeFilters = (obj) => {
    const next = { ...(obj || {}) };
    Object.keys(next).forEach((key) => {
      const value = next[key];
      if (value === undefined || value === null || value === "") {
        delete next[key];
      }
    });
    return next;
  };

  const getSupplierData = async (page, limit, filter) => {
    setLoader(true);

    try {
      const Page = page ? page : currentPage;
      const Limit = limit ? limit : pageLimit;
      const Filter = sanitizeFilters({ ...filters, ...filter });
      setCurrentPage(Page);
      setPageLimit(Limit);
      setFilters(Filter);
      let params = {
        page: Page,
        limit: Limit,

      };
      params = { ...params, ...Filter };

      const data = await SupplierServices.getSupplier(params);
      setSupplierData(data?.data?.suppliers?.rows);
      setTotalCount(data?.data?.suppliers?.count);
      setPermissions(formatPermissionData(data?.data?.permissions));
      data?.data?.permissions?.forEach((e) => {
        if (e?.route && e?.identifier && e?.permitted) {
          dispatch(addPermission(e?.route));
        }
      });
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };

  const handleFilter = (data) => {
    Debounce(() => getSupplierData(1, "", data));
  };

  const handleSupplierStatusSelect = (value) => {
    setSelectedSupplier(value);

    // Always set both keys so switching filters clears prior state.
    if (!value?.id || value?.id === "all") {
      handleFilter({ status: null, draft: null });
      return;
    }

    if (value?.id === "active") {
      handleFilter({ status: "true", draft: "false" });
      return;
    }

    if (value?.id === "inactive") {
      handleFilter({ status: "false", draft: "false" });
      return;
    }

    if (value?.id === "draft") {
      handleFilter({ status: "all", draft: "true" });
      return;
    }
  };

  useEffect(() => {
    getSupplierData();
  }, []);
  const calculateDue = (total, paid) => {
    const totalAmount = Number(total) || 0;
    const paidAmount = Number(paid) || 0;
    return totalAmount - paidAmount;
  };
  return (
    <Box sx={{ m: 4, mb: 8 }}>
      <Dialog
        open={openPopup}
        onClose={handleClosePopup}
        maxWidth="md"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            padding: "20px",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px",
          }}
        >
          <Typography variant="h6">
            {invoiceSupplier?.company_name
              ? `${invoiceSupplier.company_name} - Invoices`
              : "Supplier All Invoices"}
          </Typography>
          <IconButton onClick={handleClosePopup}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
            <Grid item xs={12} sm={5}>
              <InputField
                size={"small"}
                inputStyle={{ backgroundColor: "#f5f5f5" }}
                label={"Search"}
                value={invoiceSearch}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                placeholder={"Search"}
                onChange={(e) => {
                  const val = e.target.value;
                  setInvoiceSearch(val);
                  Debounce(() => getSupplierInvoices(invoiceSupplier?.id, 1, invoicePageLimit, val));
                }}
              />
            </Grid>
          </Grid>

          <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <Row>
                  <Cell>Invoice no.</Cell>
                  <Cell>Invoice on</Cell>
                  <Cell>Amount ($)</Cell>
                  <Cell>Status</Cell>
                  <Cell>Action</Cell>
                </Row>
              </TableHead>
              <TableBody>
                {!invoiceLoader ? (
                  invoiceBills.length > 0 ? (
                    invoiceBills.map((bill, idx) => (
                      <Row key={idx} sx={{ bgcolor: idx % 2 !== 0 && "#EEFBEE" }}>
                        <Cell>{bill?.bill_no ?? "-"}</Cell>
                        <Cell>
                          {bill?.bill_date
                            ? new Date(bill.bill_date).toLocaleDateString("en-GB")
                            : bill?.created_at
                            ? new Date(bill.created_at).toLocaleDateString("en-GB")
                            : "-"}
                        </Cell>
                        <Cell>
                          {CommaSeparator(
                            parseFloat(
                              Number(
                                bill?.bill_accounts?.reduce(
                                  (s, a) => s + parseFloat(a?.total_amount || 0),
                                  0
                                ) || 0
                              ).toFixed(2)
                            )
                          )}
                        </Cell>
                        <Cell>
                          <Typography
                            component="span"
                            sx={{
                              fontWeight: 600,
                              color:
                                bill?.pmt_status?.toString().toLowerCase() === "paid"
                                  ? Colors.primary
                                  : bill?.pmt_status?.toString().toLowerCase() === "partial"
                                  ? "#f59e0b"
                                  : "#e53e3e",
                            }}
                          >
                            {(() => {
                                const s = bill?.pmt_status?.toString().toLowerCase();
                                if (s === "paid") return "Paid";
                                if (s === "partial") return "Partial";
                                return "Unpaid";
                              })()}
                          </Typography>
                        </Cell>
                        <Cell>
                          <Typography
                            component="span"
                            sx={{ color: Colors.primary, cursor: "pointer", fontWeight: 600, textDecoration: "underline" }}
                            onClick={() => navigate(`/supplier-bill-receipt/${bill?.id}`)}
                          >
                            View
                          </Typography>
                        </Cell>
                      </Row>
                    ))
                  ) : (
                    <Row>
                      <Cell colSpan={5} align="center">No Invoices Found</Cell>
                    </Row>
                  )
                ) : (
                  <Row>
                    <Cell colSpan={5} align="center">
                      <CircularProgress size={30} sx={{ color: Colors.primary }} />
                    </Cell>
                  </Row>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {invoiceBills.length > 0 && (
            <Pagination
              currentPage={invoiceCurrentPage}
              pageSize={invoicePageLimit}
              tableCount={invoiceBills.length}
              totalCount={invoiceTotalCount}
              onPageChange={(page) =>
                getSupplierInvoices(invoiceSupplier?.id, page, invoicePageLimit, invoiceSearch)
              }
              onPageSizeChange={(size) =>
                getSupplierInvoices(invoiceSupplier?.id, 1, parseInt(size.target.value), invoiceSearch)
              }
            />
          )}
        </DialogContent>
      </Dialog>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4,
          mr: 4,
          mt: 4,
        }}
      >
        <Typography
          sx={{
            color: "#094526",
            fontFamily: "Helvetica",
            fontSize: "32px",
            fontStyle: "Bold",
            fontWeight: 700,
          }}
        >
          Supplier Listing
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box>
            <PrimaryButton
              title={"Add Supplier"}
              onClick={() => window.open("/supplier-onboarding")}
            />
          </Box>
        </Box>
      </Box>

      {/* Form Section */}
      <Box
      // sx={{
      //   boxShadow: "0px 4px 4px 0px #00000040",
      //   p: 3,
      //   borderRadius: "12px",
      // }}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={3}>
            <InputField
              size={"small"}
              inputStyle={{ backgroundColor: "#f5f5f5" }}
              label={"Search"}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              placeholder={"Search"}
              register={register("search", {
                onChange: (e) => handleFilter({ search: e.target.value }),
              })}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <SelectField
              label={"Supplier Status"}
              options={[
                { id: "all", name: "All" },
                // { id: "active", name: "Active" },
                // { id: "inactive", name: "In Active" },
                { id: "draft", name: "In Draft" },
              ]}
              selected={selectedSupplier}
              onSelect={handleSupplierStatusSelect}
              register={register("supplierStatus")}
            />
          </Grid>
        </Grid>
      </Box>

      {/* ========== Table ========== */}
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: "0px 8px 18px 0px #9B9B9B1A",
          borderRadius: 2,
          maxHeight: "calc(100vh - 330px)",
          mt: 5,
        }}
        className="table-box"
      >
        <Table stickyHeader sx={{ minWidth: 500 }}>
          <TableHead>
            <TableRow>
              {tableHead.map((item, index) => (
                <Cell className="pdf-table" key={index}>
                  {item}
                </Cell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {!loader ? (
              supplierData?.length > 0 ? (
                <Fragment>
                  {supplierData.map((item, index) => {
                    // const isSelected = selectedRows?.some(
                    //   (selected) => selected?.id === item?.id
                    // );

                    return (
                      <Row
                        key={index}
                        sx={{ bgcolor: index % 2 !== 0 && "#EEFBEE" }}
                      >
                        <Cell className="pdf-table">{item?.id ?? "-"}</Cell>
                        <Cell className="pdf-table">
                          {item.company_name ?? "-"}
                        </Cell>
                        <Cell className="pdf-table">

                          {CommaSeparator(
                            parseFloat(Number(item.supplier_banks?.[0]?.credit_amount || item.amount || 0).toFixed(2))
                          )}
                        </Cell>
                        <Cell className="pdf-table">
                          {CommaSeparator(
                            parseFloat(Number(getBalanceDue(item)).toFixed(2))
                          )}
                        </Cell>
                        <Cell className="pdf-table">
                          {item.supplier_banks?.[0]?.credit_days ?? item.credit_days ?? "-"}
                        </Cell>
                        <Cell className="pdf-table">
                          {item?.is_draft === true
                            ? "In Draft"
                            : item?.is_active === false
                              ? "In Active"
                              : "Active"}
                        </Cell>
                        <Cell className="pdf-table">
                          <IconButton
                            onClick={() => handleOpenPopup(item)}
                          >
                            <VisibilityIcon />
                            <Typography
                              component="span"
                              sx={{
                                cursor: "pointer",
                                textDecoration: "underline",
                              }}
                            >
                              Show All
                            </Typography>
                          </IconButton>
                        </Cell>
                        <Cell className="pdf-table">
                          {
                            <DropdownMenu
                              item={item}
                              permissions={permissions}
                              navigate={navigate}
                              isOpen={activeMenu === item?.id}
                              onToggle={(isOpen) =>
                                handleMenuToggle(item?.id, isOpen)
                              }
                              id={item?.id}
                              suplierListingView={() => {
                                window.open(
                                  `/supplier-detail-view/${item?.id}`,
                                );
                              }}
                              suplierListingEdit={() => {
                                window.open(`/update-supplier/${item?.id}`);
                              }}
                            // suplierListingCompleteProfile={() => {
                            //   window.open(`/complete-profile/${item?.id}`);
                            // }}
                            />
                          }
                        </Cell>
                      </Row>
                    );
                  })}
                </Fragment>
              ) : (
                <Row>
                  <Cell colSpan={11} align="center" sx={{ fontWeight: 600 }}>
                    No Data Found
                  </Cell>
                </Row>
              )
            ) : (
              <TableRow>
                <TableCell colSpan={11} align="center" sx={{ border: 0, py: 4 }}>
                  <CircularProgress size={40} sx={{ color: Colors.primary }} />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      {supplierData?.length > 0 && (
        <Pagination
          currentPage={currentPage}
          pageSize={pageLimit}
          onPageSizeChange={(size) => getSupplierData(1, size.target.value)}
          tableCount={supplierData?.length}
          totalCount={totalCount}
          onPageChange={(page) => getSupplierData(page, "")}
        />
      )}
    </Box>
  );
}

export default SupplierListing;
